module.exports = {
  google: {
    API_KEY: process.env.REACT_APP_GOOGLE_API_KEY || "",
    CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
    SECRET: process.env.REACT_APP_GOOGLE_SECRET || "",
  },
  facebook: {
    APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID || "",
  },
  api: {
    API_URL: process.env.REACT_APP_API_URL || "https://api-node.themesbrand.website",
  },
  base_url: {
    casdoor: process.env.REACT_APP_CASDOOR_URL || "https://casdoor.siga-ltda.click",
    erp_auth: process.env.REACT_APP_ERP_AUTH_URL || "https://erp-auth.siga-ltda.click",
    erp_config: process.env.REACT_APP_ERP_CONFIG_URL || "https://erp-config.siga-ltda.click",
    erp_backend: process.env.REACT_APP_ERP_BACKEND_URL || "https://erp-backend.siga-ltda.click",
    erp_img_records: process.env.REACT_APP_ERP_IMG_RECORDS_URL || "https://img-records.siga-ltda.click",
  },
};
